<template>
<div class="form">
  <div class="form__header">
    <h3>Добавить ученика</h3>
  </div>
  <div class="form__body">
      <Input 
        class="form__field" 
        v-model="formData.name" 
        label="Имя" 
        type="text" 
        id="student-name" 
        :required="true" 
      />

      <p class="form__field" v-if="!user.is_course">
        <span>Дата рождения:</span>
        <date-picker 
          :format="'DD-MM-YYYY'" 
          v-model="formData.birth_date" 
          valueType="format" 
          :default-value="new Date('2010-01-01')"
          class="required"
          :class="{
            valid: formData.birth_date,
            invalid: !formData.birth_date,
          }"
        ></date-picker>
      </p>

      <p class="form__field" v-else>
        <span>Окончание курса:</span>
        <date-picker 
          :format="'DD-MM-YYYY'" 
          v-model="formData.expired" 
          valueType="format" 
        ></date-picker>
      </p>

      <Input 
        class="form__field" 
        v-model="formData.email" 
        label="Email" 
        type="text" 
        id="student-email" 
        :required="true" 
      />

      <p class="form__field">
        <Input 
          v-model="formData.password" 
          label="Пароль" 
          :type="showpass ? 'text' : 'password'" 
          id="student-password" 
          :required="true" 
        />
        <span class="showpass" @click="showpass = !showpass" :class="showpass ? 'active' : ''" uk-tooltip="Показать пароль"></span>
      </p>

      <p class="form__field">
        <span>Класс:</span>
        <select 
          v-model="formData.class" 
          class="required"
          :class="{
            valid: formData.class,
            invalid: !formData.class,
          }"
        >
          <option value="" disabled selected>Выберите класс</option>
          <option :value="cl.id" v-for="cl in classes" :key="cl.id">{{ cl.title }}</option>
        </select>
      </p>
  </div>
  <div class="form__footer">
    <SubmitButton :isValid="isValid" @submit="sendForm" />
  </div>
</div>
</template>

<script>
import { form_mix } from "../../../mixins/form_mix";
import { mapGetters, mapActions } from 'vuex'

export default {
  mixins: [ form_mix ],
  inject: ['http'],
  name: "add-student",
  data() {
    return {
      showpass: false,
      formData: {
        name: '',
        birth_date: '',
        expired: '',
        email: '',
        password: '',
        class: ''
      },
      requiredKeys: ['name', 'birth_date', 'email', 'password', 'class']
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      price: 'prices',
      classes: 'teacher/classes'
    }),
    is_outside() {
      return this.user.is_outside || this.user.is_course ? true : false
    }
  },
  methods: {
    ...mapActions({
      getClasses: 'teacher/getClasses',
      getStudents: 'teacher/getStudents'
    }),
    sendForm() {
      this.formData.teacher_id = this.user.id;
      this.formData.is_outside = this.is_outside;

      if (this.user.is_outside) {
        this.formData.limits = this.price;
      }
      console.log(this.formData)
      this.http.post('onAddStudent', this.formData).then(res => {
        if (res.status === false) {
          swal('', res.message, 'warning')
        } else {
          this.getStudents()
          swal('Успешно!','Ученик добавлен', 'success')
          this.$emit('close-popup')
        }
      })      
    }
  }
}
</script>

<style lang="scss" scoped>
select {
  font-size: 16px;
}

.mx-datepicker {
  width: 100%;
}

.form-field {
  margin-bottom: 20px;
}
</style>
